import {
	Component,
	ElementRef,
	HostBinding,
	Inject,
	OnDestroy,
	OnInit,
	Renderer2,
	ViewEncapsulation,
	HostListener,
	Input,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import { AppConfigService } from '../core/services/config.service';
import { AppMatSidenavHelperService } from '../core/directives/app-mat-sidenav-helper/app-mat-sidenav-helper.service';
import { EnvironmentsService } from '../main/content/sections/services/environments-services';
import { IEnvironments } from './content/sections/Interfaces/IEnvironments';
import { TransactionResult } from '../core/services/interfaces/transaction-result';
import { TranslateApplicationService } from '../core/translate/translate-application-service';
import { ApplicationInfoService } from '../core/translate/application-info.service';
import { Application } from '../core/translate/models/application';
import { SitesService } from './content/sections/services/sites-services';
import { ISites } from './content/sections/Interfaces/ISites';
import { EventService } from '../main/content/sections/services/event-service';

@Component({
	selector: 'app-main',
	templateUrl: './main.component.html',
	styleUrls: ['./main.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class MainComponent implements OnInit {
	@Input() languages: Array<any> = null;
	onSettingsChanged: Subscription;
	appSettings: any;
	@HostBinding('attr.app-layout-mode') layoutMode;
	isTestingEnvironment: boolean;
	sites: Array<ISites>;
	constructor(
		private appConfig: AppConfigService,
		private platform: Platform,
		private _elementRef: ElementRef,
		private _renderer: Renderer2,
		private appMatSidenavHelperService: AppMatSidenavHelperService,
		private environmentsService: EnvironmentsService,
		private sitesService: SitesService,
		public translate: TranslateApplicationService,
		private applications: ApplicationInfoService,
		private eventService: EventService,
		@Inject(DOCUMENT) private document: any,
	) {
		this.onSettingsChanged = this.appConfig.onSettingsChanged.subscribe(
			(newSettings) => {
				this.appSettings = newSettings;
				this.layoutMode = this.appSettings.layout.mode;
			},
		);

		if (this.platform.ANDROID || this.platform.IOS) {
			this.document.body.className += ' is-mobile';
		}
	}

	ngOnInit() {
		this.getEnvironment();
		this.getSites();
		this.InitEventService();
	}

	ngOnDestroy() {
		this.onSettingsChanged.unsubscribe();
	}

	InitEventService() {
		this.eventService.recordUpdated$.subscribe((updatedRecord) => {
			if(updatedRecord == "site_list_updated") {
				this.getSites();
			}
		});
	}

	addClass(className: string) {
		this._renderer.addClass(this._elementRef.nativeElement, className);
	}

	removeClass(className: string) {
		this._renderer.removeClass(this._elementRef.nativeElement, className);
	}

	@HostListener('window:keydown.control.Enter', ['$event'])
	keyEvent(event: KeyboardEvent) {
		this.appMatSidenavHelperService.getSidenav('config-app').toggle();
	}

	getEnvironment() {
		this.environmentsService
			.GetActiveEnvironment()
			.subscribe((result: TransactionResult<IEnvironments[]>) => {
				if (!result.success) {
					return;
				}
				this.isTestingEnvironment = result.data[0].description == 'Staging' ||
											result.data[0].description == 'Development';
			}
		);
	}

	getSites() {
		this.sitesService.GetSitesByUsername().subscribe(
			(result: TransactionResult<ISites[]>) => {
				if(!result.success || result.data.length <= 0){
					return;
				}
				
				this.sites = result.data;
			},
			(error: any) => {},
		);
	}
}
